export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_EVENTS_SUCCESSFUL = 'FETCH_EVENTS_SUCCESSFUL';
export const FETCH_EVENTS_FAILED = 'FETCH_EVENTS_FAILED';

export const FETCH_SINGLE_EVENTS = 'FETCH_SINGLE_EVENTS';
export const FETCH_SINGLE_EVENTS_COMPLETE = 'FETCH_SINGLE_EVENTS_COMPLETE';
